import React, {PropTypes} from 'react';
import { connect } from 'react-redux'
// LOCAL
import MainContentAccountants from './MainContentAccountants'

// SHARED
import { createAccountantGroup, updateAccountantGroup, getAccountantGroup,
  hideCreateAccountantGroupModal, resetAccountantGroupForm } from './actions'
import onMount from '../core/onMount'


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch, // needed for onMount HOC
    onProfileFormSave: (data, newProfile)=>{
      if (newProfile) {
        dispatch(createAccountantGroup(data));
      } else {
        dispatch(updateAccountantGroup(data));
      }
    },

    handleCreatedAccountantGroupAlertOk: ()=>{
      dispatch(hideCreateAccountantGroupModal());
    },

    onAccountantGroupFormReset:()=>{
      dispatch(resetAccountantGroupForm());
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.models.user,
    ui: state.ui,
    params: ownProps.match,
    clients: state.accountants.clients
  }
}




const MountedMainContentAccountants = onMount(({dispatch}) => {
  dispatch(getAccountantGroup())
})(MainContentAccountants)


export default connect(mapStateToProps, mapDispatchToProps)(MountedMainContentAccountants)



// WEBPACK FOOTER //
// ./src/accountants/AccountantsPage.js